import styled from 'styled-components';

export const Title = styled.h4`
  font-size: 2rem;
  color: #b24a26;
  margin: 0 0 ${props => props.theme.margin};
  text-align: center;
`;



// WEBPACK FOOTER //
// ./components/ServiceTypeModal/ServiceTypeModal.style.js